module.exports = __webpack_public_path__ + "img/car_sendai21.20aa7d81.jpg";